<template lang="pug">
    DatePicker(:value="value" clearable transfer type="datetimerange" format="yyyy-MM-dd HH:mm" placement="right-end" placeholder="Select time" style="width:100%" @on-change="onChange")
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: function () {
                return ["", ""];
            },
        },
        formItem: {},
        formData: {},
    },
    methods: {
        onChange(val) {
            this.$emit("input", val);
            if (typeof this.formItem.watchField == "function") this.formItem.watchField(value, this.formData);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/DatePicker.vue